import React from "react";
import {
    ListItem,
    ListItemText,
    Collapse,
    Grid,
} from "@material-ui/core";
import CardCollapseList from "../../cardExtendList/.mixins";
import { ExpandLess, ExpandMore } from "@material-ui/icons";

//css
import StylesCss from "./styles";
const useStyles = StylesCss();

function CollapseList({ element, handleChange }) {
    const classes = useStyles();

    function parseDate(date) {
        const [newDate] = date.split(' ');
        return newDate;
    }

    function CollapseListCard() {
        return (
            <Collapse
                className={classes.cardList}
                in={element.isOpen}
                timeout="auto"
                unmountOnExit
            >
                {element.data &&
                    element.data.map((element, i) => {
                        return <CardCollapseList key={i} {...element} />;
                    })}
            </Collapse>
        );
    }
    return (
        <Grid item xs={12}>
            <ListItem
                button
                className={classes.collapse}
                onClick={() => {
                    handleChange(element);
                }}
            >
                <ListItemText
                    primary={`DATA DE ENTREGA: ${parseDate(element.DT_ENTRG)}`}
                />
                <i className={classes.icons}>
                    {element.isOpen ? <ExpandLess /> : <ExpandMore />}
                </i>
            </ListItem>
            <CollapseListCard />
        </Grid>
    );
}

export default CollapseList;
